<div class="grid" style="margin-top: 8px;">
  <div class="flex flex-column col-12">
    <div class="card">
      <div *ngIf="!analyzing" style="margin: 0 auto; text-align: center;">
        <i class="pi pi-search done pt-3 pb-2"></i>
        <p>
          <button
            (click)="start()"
            label="Analizar dispositivo"
            pButton
            pRipple
            class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
            icon="pi pi-search"
          ></button>
        </p>

      </div>


      <div *ngIf="analyzing" style="margin: 0 auto; text-align: center">
        <i class="pi pi-search analyzing pt-3 pb-2" *ngIf="progress < 100"></i>
        <p *ngIf="progress < 100">{{checkLogs}}</p>
        <i class="pi pi-check-circle done pt-1 pb-2" *ngIf="progress >= 100 && !someErrors"></i>
        <p *ngIf="progress >= 100 && !someErrors">¡No se han encontrado errores!</p>
        <i class="pi pi-exclamation-triangle warning pt-1 pb-2" *ngIf="progress >= 100 && someErrors"></i>
        <p *ngIf="progress >= 100 && someErrors">¡Se han encontrado errores!</p>
        <p-progressBar [value]="progress" [showValue]="false"></p-progressBar>

      </div>

      <div *ngIf="resultAvailable" class="mt-2">
        <p-accordion styleClass="normal-accordion" [multiple]="true">
          <p-accordionTab header="Errores de integración" [disabled]="results['blocked'].ok">
            <label>{{results['blocked'].cause}}</label>
          </p-accordionTab>
          <p-accordionTab header="Mediciones fuera de rango" [disabled]="results['outdated'].ok">
            <ngx-json-viewer [json]="results['outdated'].cause" [expanded]="false"></ngx-json-viewer>
          </p-accordionTab>
          <p-accordionTab header="Mediciones con sensores desconocidos" [disabled]="results['unmapped'].ok">
            <ngx-json-viewer [json]="results['unmapped'].cause" [expanded]="false"></ngx-json-viewer>
          </p-accordionTab>
          <p-accordionTab header="Mediciones no válidas" [disabled]="results['invalid'].ok">
            <ngx-json-viewer [json]="results['invalid'].cause" [expanded]="false"></ngx-json-viewer>
          </p-accordionTab>
          <p-accordionTab header="Errores en configuración del decoder" [disabled]="results['unk_decoder'].ok">
            <app-clipboard-label [value]="results['unk_decoder'].cause" [copiedValue]="results['unk_decoder'].message"></app-clipboard-label>
          </p-accordionTab>
          <p-accordionTab header="Errores de decodificación" [disabled]="results['decoder'].ok">
            <app-clipboard-label [value]="results['decoder'].cause" [copiedValue]="results['decoder'].message"></app-clipboard-label>
          </p-accordionTab>
        </p-accordion>
      </div>

    </div>
  </div>
</div>
